import { useRequest } from 'ahooks';
import { fetchAllCities } from '@/services/basic';
import { useEffect, useState } from 'react';
import { useReadyInfo } from '@/providers/ReadyProvider';
import { getCity } from '@/components/utils';

/**
 * 获取城市下拉框数据
 */
const useAllCities = () => {
  const { profile, allCities, setAllCities } = useReadyInfo();

  const [data, setData] = useState([]);

  const { run: getAllCities, loading } = useRequest(fetchAllCities, { manual: true });

  useEffect(() => {
    if (!allCities || !allCities?.length) {
      getAllCities(profile?.shopping_village).then((res) => {
        const data = getCity(res);
        setData(data);
        setAllCities(data);
      });
    } else {
      setData(allCities);
    }
  }, [profile, allCities]);

  return {
    data,
    loading,
  };
};

export default useAllCities;
